const Facebook = ({
  color = "var(--primary500)",
  size = 24,
  onClick = () => {},
}) => {
  return (
    <svg
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5079_92038)">
        <rect width="120" height="120" rx="10" fill={color} />
        <g clipPath="url(#clip1_5079_92038)">
          <rect
            x="39.9987"
            y="25"
            width="35"
            height="70"
            rx="10"
            fill={color}
          />
          <path
            d="M48.9333 95V62.154H39.9987V50.3278H48.9333V40.2267C48.9333 32.2892 54.2111 25 66.3722 25C71.296 25 74.937 25.4588 74.937 25.4588L74.6501 36.5025C74.6501 36.5025 70.9369 36.4673 66.8849 36.4673C62.4994 36.4673 61.7968 38.4319 61.7968 41.6925V50.3278H74.9987L74.4242 62.154H61.7968V95H48.9333"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5079_92038">
          <rect width="120" height="120" fill="white" />
        </clipPath>
        <clipPath id="clip1_5079_92038">
          <rect
            x="39.9987"
            y="25"
            width="35"
            height="70"
            rx="10"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Facebook;
